module.exports = __webpack_public_path__ + "img/pagina_principal_3.375043b5.png";